
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.87 5.642a1.069 1.069 0 010-1.511l2.807-2.808a1.069 1.069 0 011.512 0l2.807 2.808a1.069 1.069 0 11-1.512 1.511l-.982-.982v9.26a1.069 1.069 0 11-2.138 0V4.66l-.983.982a1.069 1.069 0 01-1.512 0zM12.87 10.357a1.069 1.069 0 000 1.512l2.807 2.808a1.069 1.069 0 001.512 0l2.807-2.808a1.069 1.069 0 10-1.512-1.512l-.982.983V2.079a1.07 1.07 0 00-2.138 0v9.261l-.983-.983a1.069 1.069 0 00-1.512 0z","fill":"currentColor"}})])
          )
        }
      }
    